import { FormulaCategory, FormulaState } from '../../models/formula.model';
import {
    LabelMessageStatus,
    LabelSendingCriteria,
} from '../../models/label.model';
import { ViewByName } from '../../models/live-messages.model';
import {
    METRIC_NAMES,
    TOP_PERFORMING_METRICS,
} from '../../models/metrics.model';

const labelKeys = {
    all: (active: boolean = false) => ['labels', active] as const,
    labelsByVariant: (variantType: string) =>
        [...labelKeys.all(), variantType] as const,
    labelsByComponentId: (componentTypeId: string) =>
        [...labelKeys.all(), componentTypeId] as const,
    variantDetails: (variantType: string) =>
        [...labelKeys.labelsByVariant(variantType), 'details'] as const,
    variantMetrics: (variantType: string, viewBy?: ViewByName) => [
        ...labelKeys.all(),
        variantType,
        'metrics',
        viewBy,
    ],
    labelDetailsMetrics: (
        componentTypeIds: string[],
        metrics: METRIC_NAMES[],
        rawMetrics: METRIC_NAMES[],
    ) => [
        ...labelKeys.all(),
        'details',
        'metrics',
        ...componentTypeIds,
        ...metrics,
        ...rawMetrics,
    ],
    labelDetailsByVariantTypes: (
        variantTypes: string[],
        messageStatus: LabelMessageStatus[],
        sendingCriteria: LabelSendingCriteria[],
    ) => [
        ...labelKeys.all(),
        'details',
        ...variantTypes,
        ...messageStatus,
        ...sendingCriteria,
    ],
    labelDetailsByComponentTypeIds: (
        componentTypeIds: string[],
        messageStatus: LabelMessageStatus[],
        sendingCriteria: LabelSendingCriteria[],
    ) => [
        ...labelKeys.all(),
        'details',
        ...componentTypeIds,
        ...messageStatus,
        ...sendingCriteria,
    ],
    labelIdDetails: (id: number) => [...labelKeys.all(), id, 'details'],
    labelIdChartRaw: (
        id: number,
        metricName: TOP_PERFORMING_METRICS,
        nDays: number,
    ) => [...labelKeys.all(), id, 'metrics', metricName, nDays, 'raw'],
    labelIdChartDetail: (id: number, nDays: number, viewBy: ViewByName) => [
        ...labelKeys.all(),
        id,
        'metrics',
        nDays,
        'detail',
        viewBy,
    ],
    labelCount: () => ['label-count'] as const,
    labeledAlternate: (labelId: number, status: FormulaState[]) => [
        labelId,
        'labeled-alternate',
        ...status,
    ],
    inactiveLabeledAlternate: (
        labelId: number,
        active_state: FormulaState[],
    ) => [labelId, 'inactive-alternate', ...active_state],
    labelledFormulaTriggerCount: (labelId: number) => [
        labelId,
        'trigger-count',
    ],
    labelsVariantsV1: (
        componentTypeId: string,
        formulaCategory?: FormulaCategory,
    ) => ['labels_and_variants', componentTypeId, formulaCategory],
};

export default labelKeys;
